
import { useState } from 'react';
import Hero from './components/Hero';
import SPGraphs from './components/SPGraphs';
import Benefits from './components/Benefits';
import Security from './components/Security';
import Comparison from './components/Comparison';
import Simulator from './components/Simulator';
import FinalCTA from './components/FinalCTA';
import SocialMedia from './components/SocialMedia';

export default function Home() {
  return (
    <div className="bg-black min-h-screen">
      <Hero />
      <SPGraphs />
      <Benefits />
      <Security />
      <Comparison />
      <Simulator />
      <FinalCTA />
      <SocialMedia />
    </div>
  );
}
